<div class="component-viewer">
    <mat-card  class="mat-elevation-z8">
        <mat-form-field>
            <mat-select placeholder="State" [(value)]="stateDto" (selectionChange)="onStateSelection()">
                <mat-option *ngFor="let state of states" [value]="state">{{state.state}}</mat-option>
            </mat-select>
        </mat-form-field>
        <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10"
            [updateFilterEvent]="updateFilterEvent" [filter]="filter" [data]="courses"
            (filterChanged)="getCourses()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="courses">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let course"><a mat-list-item [routerLink]="['../course', 'details', course.id]">{{course.name}}</a></td>
            </ng-container>
            <ng-container matColumnDef="shortName">
                <th mat-header-cell *matHeaderCellDef>Short Name</th>
                <td mat-cell *matCellDef="let course"> {{course.shortName}} </td>
            </ng-container>
            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let course">
                    <button mat-stroked-button>
                        Edit <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card>
</div>